import { Controller } from "@hotwired/stimulus"
import { showToast } from "../helpers/toast"
import { Turbo } from "@hotwired/turbo-rails"
import { fetchWonData, showWonModal } from "../helpers/won_modal"

export default class extends Controller {
  static targets = ["menu"]
  static values = { dealId: Number }

  connect() {
    this.boundClose = this.closeOutside.bind(this)
    document.addEventListener("click", this.boundClose)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose)
  }

  toggle(event) {
    event.stopPropagation()
    const menu = this.menuTarget
    const isHidden = menu.classList.contains("hidden")
    menu.classList.toggle("hidden")

    if (isHidden) {
      const rect = event.currentTarget.getBoundingClientRect()
      menu.style.position = "fixed"
      menu.style.top = `${rect.bottom + 4}px`
      menu.style.left = `${rect.left}px`
    }
  }

  async selectStage(event) {
    event.stopPropagation()
    const { stageId, stageName, stageWon, stageLost } = event.currentTarget.dataset
    const body = { stage_id: stageId }

    if (stageLost === "true") {
      window.location.href = `/deals/${this.dealIdValue}?open_lost_form=true`
      return
    }

    if (stageWon === "true") {
      window.location.href = `/deals/${this.dealIdValue}?open_won_form=true`
      return
    }

    this.menuTarget.classList.add("hidden")

    try {
      const csrf = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(`/deals/${this.dealIdValue}/change_stage`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrf,
          "Accept": "application/json"
        },
        body: JSON.stringify(body)
      })
      const result = await response.json()

      if (result.success) {
        const label = stageName || "nouvelle étape"
        showToast(`Étape mise à jour : ${label}`)
        Turbo.visit(window.location.href, { action: "replace" })
      } else {
        showToast(result.errors?.join(", ") || "Erreur lors du changement d'étape", "error")
      }
    } catch {
      showToast("Erreur réseau", "error")
    }
  }

  async handleWonConfirmation(body) {
    try {
      const data = await fetchWonData(this.dealIdValue)

      if (!data.needs_parent_check) {
        return confirm("Marquer comme gagné ?")
      }

      const result = await showWonModal(data.account_name, data.root_accounts)
      if (!result.confirmed) return false

      if (result.parentAccountId) {
        body.parent_account_id = result.parentAccountId
      }
      return true
    } catch {
      return confirm("Marquer comme gagné ?")
    }
  }

  closeOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }
}
